var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-badge',{attrs:{"variant":_vm.variant}},[_vm._v(_vm._s(_vm.status))]),(_vm.isErroJob && _vm.showErrorBadge)?_c('span',{staticClass:"ml-1 cursor-pointer",attrs:{"title":"Erro no Job de Integração"},on:{"click":_vm.mostrarModalErroJob}},[_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("?")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }